import React, { useRef } from 'react';

import { matchPath, Redirect, Route, RouteComponentProps, Switch, withRouter } from 'react-router-dom';

import { Selection, CommandBar, DefaultButton, IButtonProps, ICommandBarItemProps, ICommandBarStyles, IIconProps, Text, DialogType, Dialog, IDialogContentProps, DialogFooter, PrimaryButton } from '@fluentui/react';

import ProtocolsTable from '../Protocols/ProtocolsTable/ProtocolsTable';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import CustomCommandBarMenuItem from '../CustomFluentUI/CustomCommandBarMenuItem/CustomCommandBarMenuItem';


import { Ripple } from 'primereact/ripple';

import { subject, Unsubscribe } from '@casl/ability';
import abilityBuild from '../../shared/CASL/appAbility';

import { RootState } from '../../store';
import { connect, ConnectedProps } from 'react-redux';
import { checkRoles } from '../../hoc/CheckRoles';
import { ProtocolloAreaDiLavoroEF_Priority, ProtocolloAreaDiLavoroEF_State, Protocol_State, RoleContext, Visibility_Type } from '../../shared/enums';
import { IProtocol, IUor } from '../../shared/interfaces';
import protocolsService from '../../services/protocols.service';
import { toastRef } from '../Layout/Layout';
import AreaDiLavoro from '../AreaDiLavoro/AreaDiLavoro';
import CustomCommandBarButton from '../CustomFluentUI/CustomCommandBarButton/CustomCommandBarButton';
import axios, { CancelTokenSource } from 'axios';
import Utilities from '../../shared/Utilities/utilities';

const queryString = require('query-string');

const overflowProps: IButtonProps = {
    menuProps: {
        contextualMenuItemAs: CustomCommandBarMenuItem,
        items: []
    },
};
const commandBarStyles: Partial<ICommandBarStyles> = {
    root: { padding: '0 24px', borderBottom: '1px solid #eee', borderTop: '1px solid #eee' },
    primarySet: {
        '& .ms-OverflowSet-item:first-of-type': {
            display: 'flex', flexFlow: 'column', justifyContent: 'center', padding: '4px'
        }
    }
};


const addIcon: IIconProps = { iconName: 'Add' };

const workspacePathString = "/:aooId/workspace";



const mapState = (state: RootState) => ({
    currentAoo: state.sessionReducer.currentAoo,
    currentUor: state.sessionReducer.currentUor,
    currentUser: state.sessionReducer.currentUser,
    allRoles: state.sessionReducer.allRoles,
    features: state.sessionReducer.features,

})
const mapDispatch = {
}

const connector = connect(mapState, mapDispatch);
type PropsFromRedux = ConnectedProps<typeof connector>

export interface IDashboardProps {
}
type Props = IDashboardProps & RouteComponentProps & PropsFromRedux




export interface IDashboardState {
    cards: {
        key: string,
        title: string,
        amount: string,
        icon: IconProp,
        url?: string
    }[],
    commandBarItems: ICommandBarItemProps[]

    showCommandBar: boolean
    selectedProtocol?: IProtocol
    confirmDialogIsOpen?: boolean
    confirmDialogContentProps?: IDialogContentProps
    confirmDialogSubmitFunction?: Function
    forceTableRefresh?: boolean
    searchPanelIsOpen?: boolean
    editProtocolPanelIsOpen?: boolean
    selectedPriority: ProtocolloAreaDiLavoroEF_Priority
    redirectToPathname: string | undefined
}

class Dashboard extends React.Component<Props, IDashboardState> {

    cancelTokenSources = {};
    unsubscribeFromAbility: Unsubscribe = () => { };
    constructor(props) {
        super(props);
        this.state = {
            cards: [],

            commandBarItems: [],
            showCommandBar: true,
            confirmDialogIsOpen: false,
            confirmDialogContentProps: {},
            confirmDialogSubmitFunction: () => { },
            forceTableRefresh: false,
            searchPanelIsOpen: false,
            selectedPriority: ProtocolloAreaDiLavoroEF_Priority.Undefined,
            redirectToPathname: undefined
        }

    }


    componentDidMount() {

        this.unsubscribeFromAbility = abilityBuild.on('updated', () => {
            /// ho dovuto settare il timeout perch� altrimenti il component
            /// CommandBar non si aggiorna (non � chiaro il motivo)
            setTimeout(() => {
                this.updateCommandBarItems();
            }, 100)
            const parsedQueryString = queryString.parse(this.props.location.search);
            let uorId: number | undefined = parsedQueryString.uorId ? Number(parsedQueryString.uorId) : undefined;

            let prot: IProtocol = { visibilita: [{ tipologia: Visibility_Type.Proprietario, uor: { id: uorId } }] };
            if (abilityBuild.cannot('read', subject('IProtocol', prot))) {
                this.props.history.push({ pathname: '/unauthorized' });
            }
            let redirectToPathname = `/${this.props.currentAoo?.id}/today`;
            if (abilityBuild.can('use', subject('IFeature', { key: 'AreaDiLavoro', enabled: true }))) {
                redirectToPathname = `/${this.props.currentAoo?.id}/workspace`;
            }
            this.setState({ redirectToPathname: redirectToPathname });
            this.updateCommandBarItems();
            this.updateCards();
        });
    }

    componentDidUpdate(oldProps: Props, oldState: IDashboardState) {
        if (oldProps.currentUor !== this.props.currentUor || oldState.selectedProtocol !== this.state.selectedProtocol) {
            this.updateCommandBarItems();
        }

    }

    componentWillUnmount() {
        this.unsubscribeFromAbility();
        // cancello tutte le request in pending
        for (const [key, value] of Object.entries<CancelTokenSource>(this.cancelTokenSources)) {
            value.cancel(`${key} canceled`)
        }
    }

    commandBarNavigateItemHandler = (ev: any, item: any) => {
        ev.preventDefault();
        if (item !== (null || undefined) && item.url !== (null || undefined)) {
            this.props.history.push({ pathname: item.url, search: this.props.location.search });
        }
    }
    cardItemHandler = (ev, card) => {
        if (card && card.url) {
            this.props.history.push({ pathname: card.url, search: this.props.location.search });
        }
    }

    createProtocolFromHandler = () => {

        this.props.history.push({ pathname: `/${this.props.currentAoo?.id}/createfrom/${this.state.selectedProtocol!.id}`, search: this.props.location.search });

    }

    onSelectionChanged = (selection) => {
        this.setState({ selectedProtocol: selection });
    }

    onDownloadAllButtonClick = () => {
        let { currentAoo, location } = this.props;
        const parsedQueryString = queryString.parse(location.search);
        if (currentAoo && this.state.selectedProtocol?.id) {
            let protocolId = this.state.selectedProtocol.id;
            let uorId: number | undefined = parsedQueryString.uorId ? Number(parsedQueryString.uorId) : undefined;

            // se in cancelTokenSources c'� il cancelToken associato alla chiamata
            // chiamo il metodo cancel che interrompe la chiamata in pending
            this.cancelTokenSources[protocolsService.getProtocolFilesAsZip.name]?.cancel(protocolsService.getProtocolFilesAsZip.name + " Request annullata");
            // Ricreo il cancel token ad ogni request
            this.cancelTokenSources[protocolsService.getProtocolFilesAsZip.name] = axios.CancelToken.source();

            toastRef.current?.show({ severity: 'info', summary: 'Informazione', detail: `Avviato il download degli allegati`, life: 5000 });

            protocolsService
                .getProtocolFilesAsZip(currentAoo.id, uorId, protocolId, this.cancelTokenSources[protocolsService.getProtocolFilesAsZip.name].token)
                .then(zipFile => {
                    toastRef.current?.show({ severity: 'info', summary: 'Informazione', detail: `Download degli allegati completato con successo`, life: 5000 });

                    let fileBase64string = zipFile.docBase64String;
                    let fileName = zipFile.fileName;
                    if (fileBase64string && fileName) {
                        Utilities.SaveFileFromBase64(fileBase64string, fileName);
                    }
                })
                .catch(error => {

                    if (axios.isCancel(error)) {
                        //se non metto il catch partono delle chiamate tipo: static/js/vendors~main.chunk.js.map
                        console.log(error.message);
                    } else if (!error.isErrorShown) {
                        toastRef.current?.show({ severity: 'error', summary: 'Attezione', detail: `Impossibile completare il download degli allegati`, life: 5000 });

                    } else {
                        throw error;
                    }

                });
        };
    }
    updateCommandBarItems = () => {
        //this.setState({ showCommandBar: false });
        const { currentUor, currentUser, currentAoo, location } = this.props
        const newCommandBarItems: ICommandBarItemProps[] = [];

        const parsedQueryString = queryString.parse(location.search);
        let uorId: number | undefined = parsedQueryString.uorId ? Number(parsedQueryString.uorId) : undefined;

        let prot: IProtocol = { visibilita: [{ tipologia: Visibility_Type.Proprietario, uor: { id: uorId } }] };

        if (abilityBuild.can('create', subject('IProtocol', prot))) {
            newCommandBarItems.push(
                {
                    key: 'nuovoProtocollo',
                    commandBarButtonAs: () => (
                        <DefaultButton
                            primary
                            text="Nuovo"
                            iconProps={addIcon}
                            allowDisabledFocus
                            onClick={(event) => this.commandBarNavigateItemHandler(event, { url: this.props.match.url + '/new' })}

                        />
                    )
                }

            );

        }
        if (abilityBuild.can('use', subject('IFeature', { key: 'PecMail', enabled: true }))
            && abilityBuild.can('read', 'IMailPecMail')
            && currentUor && currentUor.mailboxesIn && currentUor.mailboxesIn.length > 0) {

            newCommandBarItems.push({
                key: 'pecmail',
                text: 'Pec & Mail',
                iconProps: { iconName: 'Mail' },
                onClick: (event) => this.commandBarNavigateItemHandler(event, { url: `/${this.props.currentAoo?.id}/pecmail` })


            });
        }



        if (abilityBuild.can('use', subject('IFeature', { key: 'Fascicoli', enabled: true }))
            && abilityBuild.can('read', 'IFascicolo')
            && currentUor) {

            newCommandBarItems.push({
                key: 'fascicoli',
                text: 'Fascicoli',
                iconProps: { iconName: 'DocumentSet' },
                onClick: (event) => this.commandBarNavigateItemHandler(event, { url: this.props.match.url + '/fascicoli' })

            });
        }

        if (this.state.selectedProtocol) {
            if (this.state.selectedProtocol.hasAttachments) {

                newCommandBarItems.push({
                    key: 'downloadAll',
                    text: 'Scarica tutto',
                    iconProps: { iconName: 'Download' },
                    onClick: this.onDownloadAllButtonClick
                });
            }

            // ricavo le uor in cui l'utente corrente ha ruolo Operatore
            const userOperatoreUor = currentUser?.ruoliUorContext.reduce((a: IUor[], o) => (o.uor && o.uor.aooId === currentAoo?.id && o.ruolo && o.ruolo.nome === "Operatore" && a.push(o.uor), a), []) ?? [];

            // in questo caso non va bene utilizzare abilityBuild perch� verifica se l'utente pu� eseguire
            // l'azione solo nella uor corrente, mentre l'utente pu� scegliere in quale uor
            // creare il protocollo

            if (userOperatoreUor.length > 0) {
                newCommandBarItems.push({
                    key: 'createFrom',
                    text: 'Crea da',
                    iconProps: { iconName: 'Copy' },
                    onClick: this.createProtocolFromHandler
                });
            }
        }
        let selectedCard = this.state.cards.find((card) => card.key === "drafts");
        if (this.props.history.location.pathname === selectedCard?.url
            && this.state.selectedProtocol
            && abilityBuild.can('delete', subject('IProtocol', prot))
            && (this.state.selectedProtocol.statoProtocollo === Protocol_State.InCreazione
                || this.state.selectedProtocol.statoProtocollo === Protocol_State.InCreazioneDaMail)) {
            newCommandBarItems.push({
                key: 'deleteDraft',
                text: 'Elimina bozza',
                iconProps: { iconName: 'Delete' },
                onClick: this.deleteDraftHandler
            });
        }

        const matchWorkspacePath = matchPath(location.pathname, {
            path: workspacePathString,
            exact: true
        })
        let { showCommandBar } = this.state;
        if (matchWorkspacePath) {
            showCommandBar = false;
        }
        else {
            showCommandBar = true;
        }


        this.setState({ commandBarItems: newCommandBarItems }, () => this.delayShowCommandBar(showCommandBar));

    }

    updateCards = () => {
        let _cards: any[] = [];
        if (abilityBuild.can('use', subject('IFeature', { key: 'AreaDiLavoro', enabled: true }))) {

            _cards.push({
                key: 'workspace',
                title: 'Area di lavoro',
                amount: '0',
                icon: {
                    iconName: "person-digging",
                    prefix: 'fal'
                } as IconProp,
                url: this.props.match.url + '/workspace'
            });
        }
        _cards.push({
            key: 'today',
            title: 'Protocolli di oggi',
            amount: '16',
            icon: {
                iconName: "file-certificate",
                prefix: 'fal'
            } as IconProp,
            url: this.props.match.url + '/today'
        });

        // se non � attiva la protocollazione diretta allora posso avere gli Acquisiti nel Tile Da protocollare
        // se � attiva la stampa dell'etichetta allora posso avere gli Allocati nel Tile Da protocollare
        if (abilityBuild.cannot('use', subject('IFeature', { key: 'SingleStepProtocol', enabled: true }))
            || abilityBuild.can('use', subject('IFeature', { key: 'StampaEtichetta', enabled: true }))) {


            _cards.push({

                // quelli che hanno il numero di protocollo e non sono protocollati
                key: 'acquired',
                title: 'Da protocollare',
                amount: '2',
                icon: {
                    iconName: "file",
                    prefix: 'fal'
                } as IconProp,
                url: this.props.match.url + '/acquired'

            });
        }

        _cards.push({

            // sono le bozze (sia semplici che da mail)
            key: 'drafts',
            title: 'Bozze',
            amount: '0',
            icon: {
                iconName: "file-signature",
                prefix: 'fal'
            } as IconProp,
            url: this.props.match.url + '/drafts'
        });


        this.setState({ cards: _cards });
    }

    delayShowCommandBar = (showCommandBar: boolean) => {
        /// ho dovuto settare lo stato showCommandbar dopo aver settato commandBarItems perch� altrimenti il component
        /// CommandBar non si aggiorna (non � chiaro il motivo)
        setTimeout(() => {
            this.setState({ showCommandBar: showCommandBar })
        }, 100);
    }

    //metodi per l'eliminazione della bozza in workspace
    deleteDraftHandler = () => {
        this.setState({
            confirmDialogIsOpen: true,
            confirmDialogContentProps: {
                type: DialogType.normal,
                title: 'Conferma',
                closeButtonAriaLabel: 'Close',
                subText: `Vuoi eliminare la bozza?`,
            },
            confirmDialogSubmitFunction: () => { this.deleteDraftConfirmDialogSubmit() }
        });
    }

    // Click su conferma del confirm dialog - 'Elimina'
    deleteDraftConfirmDialogSubmit = () => {
        const parsedQueryString = queryString.parse(this.props.location.search);
        let uorId: number | undefined = parsedQueryString.uorId ? Number(parsedQueryString.uorId) : undefined;

        if (this.props.currentAoo && uorId && this.state.selectedProtocol) {
            let draft: IProtocol = { ...this.state.selectedProtocol };
            let { forceTableRefresh } = this.state

            if (draft.id) {
                protocolsService.deleteDraft(this.props.currentAoo.id, uorId, draft.id)
                    .then(result => {
                        this.setState({ forceTableRefresh: !forceTableRefresh });
                        toastRef.current?.show({
                            severity: 'info',
                            summary: "Operazione completata",
                            detail: 'Bozza eliminata correttamente',
                            life: 5000
                        })

                    })
                    .catch(error => {
                        if (!error.isErrorShown) {
                            toastRef.current?.show({
                                severity: 'error',
                                summary: "Attenzione",
                                detail: 'Non \u00e8 stato possibile eliminare la bozza',
                                life: 5000
                            });
                        }
                    });
            }
            this.setState({ confirmDialogIsOpen: false, selectedProtocol: undefined });
        }
    }

    dismissConfirmDialog = () => {
        this.setState({ confirmDialogIsOpen: false })
    }

    onSelectPriorita = (index: number, key: string) => {
        console.log(index, key);
    }

    render() {


        return (
            <div className="dashboard" >

                <div className="cards-wrapper flex flex-nowrap">
                    {this.state.cards.map((card, index) => {
                        return (
                            <div className={`card ${card.url === this.props.location.pathname ? "selected" : ""}`} key={card.key} onClick={(ev) => this.cardItemHandler(ev, card)}>
                                <div className="card-content flex widget-overview-box p-ripple primary">
                                    <Ripple />
                                    <div className="hidden md:flex md:col-3 overview-box-icon">
                                        <FontAwesomeIcon icon={card.icon} size="lg" />
                                    </div>
                                    <div className="flex flex-column col-12 md:col-9">
                                        {/*<Text className="overview-box-count">{card.amount}</Text>*/}
                                        <Text className="overview-box-name uppercase">{card.title}</Text>
                                    </div>
                                </div>
                            </div>
                        )
                    }
                    )}
                </div>
                <Dialog
                    hidden={!this.state.confirmDialogIsOpen}
                    onDismiss={this.dismissConfirmDialog}
                    dialogContentProps={this.state.confirmDialogContentProps}
                >
                    <DialogFooter>
                        <PrimaryButton onClick={() => this.state.confirmDialogSubmitFunction!()} text="Conferma" />
                        <DefaultButton onClick={this.dismissConfirmDialog} text="Annulla" />
                    </DialogFooter>

                </Dialog>

                {this.state.showCommandBar &&
                    <CommandBar
                        overflowButtonProps={overflowProps}
                        items={this.state.commandBarItems}

                        styles={commandBarStyles}

                    />
                }
                <Switch>
                    <Route exact path="/:aooId/">
                        {this.props.currentAoo && this.state.redirectToPathname &&
                            <Redirect
                                to={{
                                    pathname: this.state.redirectToPathname,
                                    search: this.props.location.search,
                                }}
                            />
                        }
                    </Route>
                    <Route path={'/:aooId/workspace'} key="workspace" exact={true}
                        render={props => {
                            return (
                                <React.Fragment>
                                    <AreaDiLavoro />
                                </React.Fragment>
                            );
                        }}
                    >
                    </Route>
                    <Route path={'/:aooId/today'} key="today" exact={true}
                        render={props => {
                            return (
                                <React.Fragment>
                                    <ProtocolsTable
                                        onSelectionChanged={this.onSelectionChanged}
                                        onDownloadAllButtonClick={this.onDownloadAllButtonClick}
                                        createProtocolFromHandler={this.createProtocolFromHandler}
                                    />
                                </React.Fragment>
                            );
                        }}
                    >
                    </Route>
                    <Route path={'/:aooId/acquired'} key="acquired" exact={true}
                        render={props => {
                            return (
                                <React.Fragment>
                                    <ProtocolsTable
                                        onSelectionChanged={this.onSelectionChanged}
                                        onDownloadAllButtonClick={this.onDownloadAllButtonClick}
                                        createProtocolFromHandler={this.createProtocolFromHandler}
                                    />
                                </React.Fragment>
                            );
                        }}
                    >
                    </Route>
                    <Route path={'/:aooId/drafts'} key="drafts" exact={true}
                        render={props => {
                            return (
                                <React.Fragment>
                                    <ProtocolsTable
                                        onSelectionChanged={this.onSelectionChanged}
                                        onDownloadAllButtonClick={this.onDownloadAllButtonClick}
                                        forceTableRefresh={this.state.forceTableRefresh}
                                        createProtocolFromHandler={this.createProtocolFromHandler}
                                        deleteDraftHandler={this.deleteDraftHandler}
                                    />
                                </React.Fragment>
                            );
                        }}
                    >
                    </Route>

                </Switch>


            </div>
        )

    }
}

export default connector(withRouter(checkRoles(Dashboard, RoleContext.Uor)));



